import React, { createContext, useEffect, useState } from "react";
import { apiPaths, getData } from "../modules/platform-components/api-integration-util";
import { getUserDetails } from "../modules/platform-components/utils/shared-data.service";

export const AppContext = createContext()
export const AppContextProvider = (props) => {
    const [batches, setBatches] = useState([])
    const [branches, setBranches] = useState([]);
    const [courses, setCourses] = useState([])
    const [subjects, setSubjects] = useState([]);
    const [tags, setTags] = useState([]);
    const [topics, setTopics] = useState([]);
    const [users, setUsers] = useState([]);
    const [roles, setRoles] = useState([]);
    const [userSubjectMap, setUserSubjectMap] = useState([]);

    useEffect(() => {
        if(getUserDetails().email) {
            getBatches();
            getBranches();
            getCourses();
            getSubjects();
            getTags();
            getTopics();
            getUsers();
            getUserSubjectMap()
            getRoles();
        }
    }, []);

    const getBatches = () => {
        getData(apiPaths.batches, { data: {} })
        .then((data) => {
            if(data.result && data.result.length > 0) {
                setBatches(data.result);        
            }
        })
    }

    const getBranches = () => {
        getData(apiPaths.branches, { data: {} })
        .then((data) => {
            if(data.result && data.result.length > 0) {
                setBranches(data.result);
            }
        })
    }

    const getCourses = () => {
        getData(apiPaths.courses, { data: {} })
        .then((data) => {
            if(data.result && data.result.length > 0) {
                setCourses(data.result);
            }
        })
    }

    const getSubjects = () => {
        getData(apiPaths.subjects, { data: {} })
        .then((data) => {
            if(data.result && data.result.length > 0) {
                setSubjects(data.result);
            }
        })
    }

    const getTags = () => {
        getData(apiPaths.tags, { data: {} })
        .then((data) => {
            if(data.result && data.result.length > 0) {
                setTags(data.result);
            }
        })
    }

    const getTopics = () => {
        getData(apiPaths.topics, { data: {} })
        .then((data) => {
            if(data.result && data.result.length > 0) {
                setTopics(data.result);
            }
        })
    }

    const getUsers = () => {
        getData(`${apiPaths.usersList}?userEmail=${getUserDetails().email}`, { data: {
            headers: { tenantId: getUserDetails().tenantId },
            params: { userEmail: getUserDetails().email}
        } })
        .then((data) => {
            if(data.result && data.result.length > 0) {
                setUsers(data.result);
            }
        })
    }

    const getRoles = () => {
        getData(`${apiPaths.roles}?userEmail=${getUserDetails().email}`, { data: {
            headers: { tenantId: getUserDetails().tenantId },
            params: { userEmail: getUserDetails().email}
        } })
        .then((data) => {
            if(data.result && data.result.length > 0) {
                setRoles(data.result);
            }
        })
    }

    const getUserSubjectMap = () => {
        getData(`${apiPaths.listUserSubjectMap}`, { data: {
            headers: { tenantId: getUserDetails().tenantId, userEmail: getUserDetails().email },
        } })
        .then((data) => {
            if(data.result && data.result.length > 0) {
                setUserSubjectMap(data.result);
            }
        })
    }

    return (
        <AppContext.Provider
            value={{
                batches,
                branches,
                courses,
                subjects,
                tags,
                topics,
                users,
                roles,
                userSubjectMap,
                getBranches,
                getBatches,
                getCourses,
                getSubjects,
                getTags,
                getTopics,
                getUsers,
                getRoles,
                getUserSubjectMap
            }}
        >
            {props.children}
        </AppContext.Provider>
    );
};
